import { css } from '@emotion/css';

export const iconButtonStyles = css`
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.4rem;
`;

export const fillEvenOdd = css`
  fill-rule: evenodd;
`;
